module.exports = __webpack_public_path__ + "media/public/images/icon-success-3aec5b118dfcaaafa5246f1a0052ec78.svg";